<template>
  <app-content class="software-license">
    <div slot="breadcrumb-custom" class="software-license__breadcrumb-custom">
      <b-button
        class="no-internal-print"
        variant="outline-primary"
        @click="print()"
      >
      {{ $t('general.print') }}
      </b-button>
    </div>
    <software-license-view :for-print="false"/>
  </app-content>
</template>

<script>
import print from '@/services/print';
import SoftwareLicenseView from '@/domain/components/generalPanel/softwareLicense/SoftwareLicenseView';

export default {
  components: {
    SoftwareLicenseView,
  },
  methods: {
    print,
  },
};
</script>
